const buttonComponentMixin = {
  props: {
    colour: {
      type: String,
      required: false,
      default: 'grey',
      validate: ['grey', 'white', 'primary', 'secondary', 'teal'].includes,
    },
    textColour: {
      type: String,
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
      validate: ['solid', 'text', 'outline', 'transparent'].includes,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validate: ['small', 'medium', 'large'].includes,
    },
    noHoverState: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    nowrap: {
      type: Boolean,
      required: false,
      default: false,
    },
    underlined: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    baseClasses() {
      let classes = `button--${this.colour} button--${this.type} button--${this.size}`

      if (this.noHoverState) {
        classes = `${classes} button--no-hover`
      }
      if (this.fullWidth) {
        classes = `${classes} button--full-width`
      }
      if (this.nowrap) {
        classes = `${classes} button--nowrap`
      }
      if (this.textColour) {
        classes = `${classes} button--text-${this.textColour}`
      }
      if (this.underlined) {
        classes = `${classes} button--underlined`
      }

      return classes
    },
    iconColour() {
      let iconColour = this.colour

      if (this.type === 'solid') {
        iconColour = ['primary', 'secondary', 'success', 'danger', 'teal'].includes(this.colour) ? 'white' : 'black'
      } else if (iconColour === 'grey') {
        iconColour = 'black'
      }

      return iconColour
    },
  },
  methods: {
    mouseenterHandler(event) {
      this.$emit('mouseenter', event)
    },
    mouseleaveHandler(event) {
      this.$emit('mouseleave', event)
    },
    clickHandler(event) {
      this.$emit('click', event)
    },
  },
}

export default buttonComponentMixin
